import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField/TextField';
import { WithStyles } from 'decorators/withStyles';
import { IExitPopUp } from 'interfaces/IExitPopUp';
import React, { PureComponent } from 'react';

interface IProps {
  changeTime?: any;
  classes?: any;
  exitPopUp?: IExitPopUp;
  enableExitPopUpTime?: any;
}

@WithStyles(() => ({
  content: {
    display: 'flex',
    flexDirection: 'column'
  },
  inputRadius: {
    borderRadius: '0 4px 4px 0'
  },
  inputLabel: {
    top: 6,
    left: 2
  },
  labelSwitch: {
    margin: '10px 0 4px -8px'
  }
}))
export default class TimerForm extends PureComponent<IProps, null> {
  changeTime = (event: any) => {
    this.setState({ time: event.target.value });
  };
  render() {
    if (!this.props) {
      return null;
    }
    const { classes, exitPopUp } = this.props;
    return (
      <div className={classes.content}>
        <FormControlLabel
          disabled={!exitPopUp.enabled}
          onChange={this.props.enableExitPopUpTime}
          classes={{ root: classes.labelSwitch }}
          control={<Switch disableRipple checked={exitPopUp.timer.enabled} />}
          label={'Ativar Contagem Regressiva'}
        />
        <TextField
          disabled={!exitPopUp.timer.enabled}
          type="number"
          onChange={this.props.changeTime}
          value={exitPopUp.timer.time}
          label={'Tempo (min)'}
          InputProps={{
            classes: { root: classes.inputRadius },
            inputProps: { min: 1, max: 99 }
          }}
          InputLabelProps={{ classes: { root: classes.inputLabel } }}
        />
      </div>
    );
  }
}
